var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty3Light(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-svgs-path": "theme_todoist/project_new.svg",
    viewBox: "0 0 220 200",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2550 -240)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Project",
    transform: "matrix(.73333 0 0 .66667 1230 306.667)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1800-100h300v300h-300z"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1800-100h300v300h-300z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18109 1337h9v9h-9z",
    transform: "matrix(1.59821 1.015 -.92272 1.75803 -25785.614 -20544.7)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.86513 0 0 1.04787 -11687.213 -775.609)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M15684.8 780h160v120h-160z"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15684.8 780h160v120h-160z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 1.23,
    transform: "matrix(.5418 -.69624 .5418 .69624 14740.5 333.948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 1.23,
    transform: "matrix(.5418 -.69624 .5418 .69624 14755.1 333.948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 1.23,
    transform: "matrix(.5418 -.69624 .5418 .69624 14769.6 333.948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 1.23,
    transform: "matrix(.5418 -.69624 .5418 .69624 14784.1 333.948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 1.23,
    transform: "matrix(.5418 -.69624 .5418 .69624 14798.7 333.948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 1.23,
    transform: "matrix(.5418 -.69624 .5418 .69624 14813.2 333.948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 1.23,
    transform: "matrix(.5418 -.69624 .5418 .69624 14827.8 333.948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 1.23,
    transform: "matrix(.5418 -.69624 .5418 .69624 14842.3 333.948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 1.23,
    transform: "matrix(.5418 -.69624 .5418 .69624 14856.9 333.948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 1.23,
    transform: "matrix(.5418 -.69624 .5418 .69624 14871.4 333.948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 1.23,
    transform: "matrix(.5418 -.69624 .5418 .69624 14886 333.948)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 1.23,
    transform: "scale(1.15298 .69584) rotate(45 7230.737 17078.721)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 1.23,
    transform: "scale(1.15298 .69584) rotate(45 7207.816 17088.215)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 1.23,
    transform: "scale(1.15298 .69584) rotate(45 7184.896 17097.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 1.23,
    transform: "scale(1.15298 .69584) rotate(45 7161.975 17107.203)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 1.23,
    transform: "scale(1.15298 .69584) rotate(45 7139.054 17116.697)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 1.23,
    transform: "scale(1.15298 .69584) rotate(45 7116.134 17126.191)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 1.23,
    transform: "matrix(.81528 .49203 -.81528 .49203 16365.8 2.273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 1.23,
    transform: "scale(1.15298 .69584) rotate(45 7070.293 17145.18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 1.23,
    transform: "scale(1.15298 .69584) rotate(45 7047.372 17154.673)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 1.23,
    transform: "scale(1.15298 .69584) rotate(45 7024.451 17164.167)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 1.23,
    transform: "scale(1.15298 .69584) rotate(45 7001.53 17173.661)"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 3,
    d: "M15684.8 780h160v120h-160z",
    transform: "matrix(.86513 0 0 1.04787 -11687.213 -775.609)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9e4e2",
    stroke: "#f9e4e2",
    strokeWidth: 5.65,
    d: "M15684.8 780h160v120h-160z",
    transform: "matrix(.48974 -.05314 .04644 .51779 -5882.034 446.225)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15821.8 748c-3.4 0-6.5-1.779-8.3-4.682-3.6-6.189-9.7-16.318-9.7-16.318l4.1-.234 11.6 10.234h44.9c5.9 0 11.3 3.023 14.4 8-3.3 1.964-7.1 3-11 3h-46z",
    fill: "#fff",
    transform: "scale(.8699 .9569) rotate(-24.278 7399.755 32199.373)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15779 760.964l-1.8 32.631 5.6 1.144 5.6-20.173",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.25,
    transform: "matrix(1.05569 -.52378 -.67383 -.7138 -14265.284 8862.47)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15761.1 770.276l-.1 2.006",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 4.08,
    transform: "matrix(.84055 -.41704 -.53651 -.56834 -10948.475 7058.855)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15761.1 770.276l-.1 2.006",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 4.08,
    transform: "matrix(.84055 -.41704 -.53651 -.56834 -10954.38 7062.02)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15761.1 770.276l-.1 2.006",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 4.08,
    transform: "matrix(.84055 -.41704 -.53651 -.56834 -10942.53 7056.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15761.1 770.276l-.1 2.006",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 4.08,
    transform: "matrix(.84055 -.41704 -.53651 -.56834 -10936.611 7053.44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15761.1 770.276l-.1 2.006",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 4.08,
    transform: "matrix(.84055 -.41704 -.53651 -.56834 -10966.23 7067.78)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15761.1 770.276l-.1 2.006",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 4.08,
    transform: "matrix(.84055 -.41704 -.53651 -.56834 -10960.311 7065.17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9e4e2",
    stroke: "#f9e4e2",
    strokeWidth: 2.52,
    d: "M15787.8 921h11v9h-11z",
    transform: "matrix(.96962 0 0 1.3036 -13412.49 -1060.603)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15839.2 825.041c.7-1.138 1.5-2.228 2.5-3.096 6.4-5.324 11.3 2.485 11 8.634-.2 5.801-3.3 9.438-7.4 12.529",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 1.81,
    transform: "matrix(1.5076 0 0 1.65835 -21838.422 -1340.308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15844.8 780h-160v67.21c0 29.155 35.9 52.79 80 52.79 0 0 0 0 0 0 44.2 0 80-23.635 80-52.79V780z",
    fill: "#f9e4e2",
    stroke: "#f9e4e2",
    strokeWidth: 7.37,
    transform: "matrix(.28815 0 0 .48032 -2523.893 -348.064)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15767.1 900s0 0 0 0c42.9 0 77.7-24.096 77.7-53.821V780",
    fill: "none",
    stroke: "#eca19a",
    strokeWidth: 7.26,
    transform: "matrix(-.3023 0 0 .48032 6785.868 -348.064)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.83854 0 0 2.02239 -27080.39 -1626.718)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15827.3,
    cy: 817.5,
    r: 12.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15827.3,
    cy: 817.5,
    r: 12.5
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15827.3,
    cy: 817.5,
    r: 12.5,
    fill: "#da4c3f",
    stroke: "#da4c3f",
    strokeWidth: 1.48,
    transform: "translate(0 12.5)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 15827.3,
    cy: 817.5,
    r: 12.5,
    fill: "none",
    stroke: "#eca19a",
    strokeWidth: 1.48
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15832.4 728.72c11.5 4.673 19 15.651 13.8 28.118-1.6 3.94-4.3 8.309-8.9 9.243-9.9 2.029-9.7-13.216.2-9.824 1.3.46 2.5 1.217 3.6 2.117 1.4 1.111 2.4 2.597 3.1 4.198 3.5 8.404-3 14.033-7 20.416-2.8 4.582-4.4 10.496-4.3 15.928",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 2.07,
    transform: "matrix(1.35726 0 0 1.41058 -19467.461 -1111.158)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15807.6 726.151c-10.3 11.972-14 27.991-8.2 43.039 1.7 4.446 5.2 7.571 7.3 11.748",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 2.07,
    transform: "matrix(1.35726 0 0 1.41058 -19444.825 -1117.963)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15739.5 990.429c7 1.038 14.3.248 21.4.334",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 2.3,
    transform: "matrix(1.1851 0 0 1.3036 -16740.317 -1143.38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15739.5 990.429c7 1.038 14.3.248 21.4.334",
    fill: "none",
    stroke: "#f9e4e2",
    strokeWidth: 2.3,
    transform: "matrix(1.1851 0 0 1.3036 -16740.317 -1134.217)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9e4e2",
    stroke: "#f9e4e2",
    strokeWidth: 19.43,
    d: "M15684.8 780h160v120h-160z",
    transform: "matrix(.11908 0 0 .17464 -29.399 -2.47)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15739.5 990.429c7 1.038 14.3.248 21.4.334",
    fill: "none",
    stroke: "#eca19a",
    strokeWidth: 2.3,
    transform: "matrix(1.1851 0 0 1.3036 -16809.045 -1151.473)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15739.5 990.429c7 1.038 14.3.248 21.4.334",
    fill: "none",
    stroke: "#eca19a",
    strokeWidth: 2.3,
    transform: "matrix(1.1851 0 0 1.3036 -16809.181 -1143.394)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9e4e2",
    stroke: "#f9e4e2",
    strokeWidth: 19.43,
    d: "M15684.8 780h160v120h-160z",
    transform: "matrix(.11908 0 0 .17464 185.684 -38.62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15739.5 990.429c7 1.038 14.3.248 21.4.334",
    fill: "none",
    stroke: "#eca19a",
    strokeWidth: 2.3,
    transform: "matrix(1.1851 0 0 1.3036 -16593.999 -1187.633)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15739.5 990.429c7 1.038 14.3.248 21.4.334",
    fill: "none",
    stroke: "#eca19a",
    strokeWidth: 2.3,
    transform: "matrix(1.1851 0 0 1.3036 -16594.135 -1179.554)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9e4e2",
    stroke: "#f9e4e2",
    strokeWidth: 7.17,
    d: "M15684.8 780h160v120h-160z",
    transform: "matrix(.35179 .10647 -.1048 .41897 -3435.418 -1866.994)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15831.8 988v10l7.1-7.071-7.1 7.071h10-10l7.1 7.07-7.1-7.07v10-10l-7 7.07 7-7.07h-10 10l-7-7.071 7 7.071v-10z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2.68,
    transform: "matrix(1.52681 0 0 1.67949 -22149.468 -1512.736)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15825.8,
    cy: 996,
    r: 3,
    fill: "#f9e4e2",
    stroke: "#f9e4e2",
    strokeWidth: 3.45,
    transform: "matrix(.79006 0 0 .86907 -10481.019 -702.049)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9e4e2",
    stroke: "#f9e4e2",
    strokeWidth: 15.62,
    d: "M15684.8 780h160v120h-160z",
    transform: "matrix(.14814 0 0 .21727 -507.723 -73.51)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18067.6 1376.14c.2.67 3.4 3.86 3.4 3.86l8.3-8.55",
    fill: "none",
    stroke: "#da4c3f",
    strokeWidth: 1.48,
    strokeLinejoin: "miter",
    transform: "matrix(1.84138 0 0 2.02551 -31443.22 -2680.722)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9e4e2",
    stroke: "#f9e4e2",
    strokeWidth: 15.62,
    d: "M15684.8 780h160v120h-160z",
    transform: "matrix(.14814 0 0 .21727 -380.316 -168.218)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18067.6 1376.14c.2.67 3.4 3.86 3.4 3.86l8.3-8.55",
    fill: "none",
    stroke: "#da4c3f",
    strokeWidth: 1.48,
    strokeLinejoin: "miter",
    transform: "matrix(1.84138 0 0 2.02551 -31315.856 -2775.425)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15800.4 868.603l-36.7-30.682-37.6 30.682v30.508h74.3v-30.508z",
    fill: "#eca19a",
    fillOpacity: 0.75,
    transform: "matrix(.85034 0 0 .9025 -11452.5 -686.157)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty3Light);
export default __webpack_public_path__ + "static/media/empty-3-light.e383b697c11bd2da62b4b647bc30872f.svg";
export { ForwardRef as ReactComponent };